module.exports = __webpack_public_path__ + "img/guizhouHints_8.6837ce63.jpg";